export default {"src":"/_next/static/media/icon_back_arrow_white.00586951.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};